import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import FirebaseAuthService from '../services/firebaseAuthService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const firebaseAuth = new FirebaseAuthService();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
      
      if (user) {
        // User is signed in
        localStorage.setItem('access_token', user.accessToken || 'firebase_user');
        localStorage.setItem('user_id', user.uid);
        localStorage.setItem('user_name', user.displayName || user.email);
        localStorage.setItem('user_email', user.email);
        localStorage.setItem('user_image', user.photoURL || '');
      } else {
        // User is signed out
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_image');
      }
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    loading,
    firebaseAuth,
    login: firebaseAuth.login.bind(firebaseAuth),
    register: firebaseAuth.register.bind(firebaseAuth),
    logout: firebaseAuth.logout.bind(firebaseAuth),
    signInWithGoogle: firebaseAuth.signInWithGoogle.bind(firebaseAuth),
    resetPassword: firebaseAuth.resetPassword.bind(firebaseAuth),
    getProfileData: firebaseAuth.getProfileData.bind(firebaseAuth)
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 